import { render } from "./ChatGroupAddReadersModal.vue?vue&type=template&id=6306b441"
import script from "./ChatGroupAddReadersModal.vue?vue&type=script&lang=js"
export * from "./ChatGroupAddReadersModal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./ChatGroupAddReadersModal.vue?vue&type=style&index=1&id=6306b441&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__